import * as React from 'react';

import * as classNames from "classnames";
import './FormTemplatesPage.scss';

import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";

import ReactSelectClass from "react-select";

import ReactTable, { Column, RowInfo } from 'react-table';



import * as ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';

import { DefaultLayout, RestrictedLayout, UnrestrictedLayout, SubMenu } from "../../../components/layouts/index";

import * as FormTemplateActions from '../../../actions/formTemplates';
import * as PagingActions from '../../../actions/pages/pagingPage';

import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { convertToShortDateString, convertToDateTimeString, convertToApproximateDateString } from "../../../helpers/date";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { ILinkProps } from "../../../components/routing/Link";
import { INavItem } from "../../../components/layouts/NavMenu/NavMenu";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import { setModalTitle } from "../../../helpers/modalHelper";
import { Modal, NotificationAlert, Placeholder } from "../../../components/common/index";

import * as AuthenticationHelper from '../../../helpers/authentication';
import * as AuthorisationDefinitions from '../../../constants/authorisationDefinitions';
import { ModalSize } from '../../../enumerations/ModalSize';
import { Form, actions, Control } from 'react-redux-form';
import { TextAreaFormInput, FormFilterInput } from '../../../components/form';

import { QALookupsLayout } from '../../index';

interface IFormTemplatesPageProps {

    location: Location;
    history: History;

    // From state
    formTemplates: Dtos.FormTemplate[];
    formFilter: IFormFilter;

    loadingFormTemplates: boolean;
    loadFormTemplatesSuccess: boolean;
    loadFormTemplatesFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    formRoles?: Dtos.RoleType[];

    pageSize: number;
}

interface IFormTemplatesPageActions {
    clearFormTemplates: FormTemplateActions.IFormTemplateClearActionCreator;
    loadFormTemplates: FormTemplateActions.IFormTemplateLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: FormTemplateActions.IFormTemplateFilterActionCreator;

    setPageSize: PagingActions.IPagingPageSizeChangedStateActionCreator;
}

type FormTemplatesPageProps = IFormTemplatesPageProps & IFormTemplatesPageActions;

const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex"
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer"
}

class FormTemplatesPage extends React.PureComponent<FormTemplatesPageProps, any> {

    constructor(props: FormTemplatesPageProps) {
        super(props);

        this.clearFormTemplates = this.clearFormTemplates.bind(this);
    }

    componentDidMount() {
        const {
            loadFormTemplates
        } = this.props;

        loadFormTemplates();
    }

    componentWillReceiveProps(nextProps: FormTemplatesPageProps) {
    }

    componentDidUpdate(prevProps: FormTemplatesPageProps, prevState) {
        const {
            navigateReplace
        } = this.props
    }

    componentWillUpdate(nextProps: FormTemplatesPageProps) {
    }

    componentWillUnmount() {
        this.clearFormTemplates();
    }

    clearFormTemplates() {
        this.props.clearFormTemplates();
    }

    showFormTemplates(): boolean {
        const {
            loadingFormTemplates,
            loadFormTemplatesSuccess
        } = this.props

        if (!loadingFormTemplates && loadFormTemplatesSuccess) {
            return true;
        }

        return false;
    }

    render() {

        const {
            loadingFormTemplates
        } = this.props;

        return <QALookupsLayout loading={loadingFormTemplates} permission={Dtos.Permission.FormTemplatesView}>
            {this.renderContent()}
        </QALookupsLayout>;
    }

    renderContent() {
        const {
            permissions
        } = this.props;

        return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Form Templates</h2>
                </div>
                <div className="col-6" style={{ textAlign: 'right' }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.FormTemplatesCreate) && (
                        <Link className={"btn btn-primary"} url={"/settings/qa/formtemplates/create"}>Create</Link>
                    )}
                </div>
            </div>
            {
                !this.showFormTemplates() ?
                    "Loading Form Templates" :
                    null
            }
            {
                this.showFormTemplates() ?
                    <div className="patient-tables mt-2">
                        {
                            this.createTable()
                        }
                    </div> :
                    null
            }
        </div>
    }

    createTable() {

        const {
            formTemplates,
            pageSize,
            setPageSize
        } = this.props

        if (!formTemplates || formTemplates.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no form templates to view.</span>
            </div>
        }

        const showPagination = formTemplates.length > pageSize;

        return <div className="table-wrapper mb-3">
            <ReactTable
                data={formTemplates}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? pageSize : formTemplates.length}
                pageSize={showPagination ? pageSize : formTemplates.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable mb-3"
                noDataText="There are currently no form templates to display"
                resizable={false}
                onPageSizeChange={val => setPageSize(val)}
                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {

                            const url: string = "/settings/qa/formtemplates/" + rowInfo.original.id;
                            this.props.navigate(url);

                            if (handleOriginal) {
                                handleOriginal()
                            }

                        }
                    }
                }}
                columns={[
                    {
                        id: "id",
                        Header: ' ',
                        accessor: "id",
                        className: "d-flex align-items-center justify-content-center",
                        maxWidth: 50,
                        Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
                    },
                    {
                        id: "name",
                        Header: 'Name',
                        accessor: 'name',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    }
                ]}
            />
        </div>

    }

}

const mapStateToProps = (state: ITmdState, ownProps: FormTemplatesPageProps): IFormTemplatesPageProps => {

    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        history: ownProps.history,
        location: state.routing.location,

        formTemplates: state.formTemplates.formFilteredData!,
        formFilter: state.formTemplates.formFilter,

        loadingFormTemplates: state.formTemplates.loadState && state.formTemplates.loadState.status == RequestState.Pending,
        loadFormTemplatesSuccess: state.formTemplates.loadState && state.formTemplates.loadState.status == RequestState.Success,
        loadFormTemplatesFailure: state.formTemplates.loadState && state.formTemplates.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        formRoles: state.user.formRoles,

        pageSize: state.pagingPage.pageSize
    };
};

const mapDispatchToProps = (dispatch): IFormTemplatesPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadFormTemplates: bindActionCreators(FormTemplateActions.LoadFormTemplate, dispatch),
        clearFormTemplates: bindActionCreators(FormTemplateActions.Clear, dispatch),

        filter: bindActionCreators(FormTemplateActions.Filter, dispatch),

        setPageSize: bindActionCreators(PagingActions.PageSizeChanged, dispatch)
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(FormTemplatesPage);
